import { render } from "./TheSheetsCommentsDialog.vue?vue&type=template&id=20266dc0&ts=true"
import script from "./TheSheetsCommentsDialog.vue?vue&type=script&lang=ts"
export * from "./TheSheetsCommentsDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__